<app-spinner *ngIf="isLoading"></app-spinner>

<!-- Wrapper esterno per l'intestazione e la colonna -->
<div *ngIf="!isLoading" class="bg-gray-100 shadow-md flex flex-col h-full bg-fixed">

  <!-- Intestazione sopra la colonna con bordo nero e padding ridotto -->
  <div class="intestazione sticky top-0 justify-between items-center p-2  border-2 border-x border-y border-gray-300 cursor-pointer"
       style="z-index: 2500"
       [ngClass]="{'bg-[#FB699C]': isHighlightRed, 'bg-white': !isHighlightRed}"
       (click)="onChangePotenza(prestazione?._id || '')"
  > <!-- padding ridotto a p-2 -->
    <!-- Contenitore centrale per il titolo e il sottotitolo -->
    <div class="flex-grow text-center">
      <div class="p-2 text-lg font-bold">
        {{ titlePrestazione }}
        <span *ngIf="isHighlightRed" class="font-bold"> (Potenza alterata)</span>
      </div>
    </div>
  </div>

  <!-- Colonna con il riferimento #colonnaRef -->
  <div #colonnaRef class="relative flex-grow flex flex-col border border-gray-300 h-[1700px]">
    <!-- Riga per ogni ora nell'intervallo -->
    <div *ngFor="let slot of slots"
         class="hour-line flex border-t border-gray-300 items-stretch"
         [ngClass]="{'bg-gray-200': (slot.defaultBlock || isBlocked(slot))}"
         [ngStyle]="{'height': 100 / slots.length + '%'}"
    >
      <!-- Colonna per mostrare l'ora con bordo a destra tratteggiato -->
      <div class="w-1/6 text-center h-full border-r-2 border-dashed border-r-gray-300 text-gray-500">
        {{ slot.startTime }}
      </div>
      <div class="w-5/6 relative h-full">
        <!-- Utilizzo della sintassi 'as' per assegnare il risultato a una variabile locale 'event' -->
        <button *ngIf="findEventByTime(slot.startTime) as event; else freeSlot"
                class="event absolute bg-blue-500 rounded shadow w-full h-full flex justify-between items-center text-base font-bold"
                [ngClass]="getEventClass(event.prenotazione)"
                (click)="eventSelected.emit({prestazione: prestazione, prenotazione: event.prenotazione, hour: slot.hour, minutes: slot.startMinute, isVisible: true})"
        >
          <!-- Utilizzo della variabile 'event' per accedere alle sue proprietà -->
          <span class="text-white flex items-center justify-start px-3">
              {{ event.name + ' ' }}
          </span>
          <span class="text-white  flex items-center justify-end px-3">
              <span class="mr-2">
                <ng-container *ngIf="event.prenotazione.prezzo && event.prenotazione.prezzo !== 0">
                  {{ event.prenotazione.prezzo }}€
                </ng-container>
               {{ event.abbonamento }}
              </span>
            <!-- Pulsante a cerchio rosso che appare quando l'attributo timer non è valorizzato -->
              <button (click)="onStartTimer(event.prenotazione._id); $event.stopPropagation()"
                      *ngIf="!event.prenotazione.timer" class="bg-coka-pink rounded-full w-6 h-6"></button>

            <!-- Timer che scorre -->
            <span
              *ngIf="event.prenotazione.timer">{{ getTimePassed(event.prenotazione.timer, event.prenotazione.timerEnd, event.prenotazione) }} </span>

            <!-- Pulsante per fermare il timer -->
            <button (click)="onStartTimer(event.prenotazione._id); $event.stopPropagation()"
                    *ngIf="event.prenotazione.timer && !event.prenotazione.timerEnd && getEventClass(event.prenotazione).includes('animate-blink')"
                    class="bg-amber-50 rounded-full w-6 h-6 ml-2">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                   fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                        d="M8 5a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8Zm7 0a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1Z"
                        clip-rule="evenodd"/>
                </svg>

            </button>

          </span>
        </button>

        <!-- Slot vuoto, possibile quindi l'inserimento di una prenotazione -->
        <ng-template #freeSlot>
          <button
                  class="slot absolute w-full h-full rounded focus:border-2 focus:border-coka-pink"
                  (click)="slotSelected.emit({prestazione: prestazione, date: date, hour: slot.startTime, minutes: slot.startTime, isVisible: true})"
          >
            <div class="text-center font-bold opacity-20">{{ prestazione.nome }}</div>
          </button>
        </ng-template>

      </div>
    </div>
    <div class="hour-line flex  flex-col border-t border-gray-300 items-stretch border-b-0"
         [ngStyle]="{'height': '4%'}"
    >
      <span>Prenotazioni: <b>{{ conteggioPrenotazioni.prenotazioni }}</b></span>
      <span>Prezzo: <b>{{ formatPrice(conteggioPrenotazioni.prezzi) }}€</b></span>
    </div>

    <!-- Indicatore del tempo che si muove nella colonna -->
    <div class="time-indicator absolute z-10" [ngStyle]="{'top': timePosition + 'px'}">
      <div class="dot bg-coka-pink rounded-full w-3 h-3 absolute top-1/2 transform -translate-y-1/2"></div>
    </div>
  </div>
</div>
